import { SxProps } from '@mui/material';

export const textDesc: SxProps = {
  color: '#939393',
  fontFamily: 'Yelo',
  fontSize: '12px',
};

export const userInfoBlock: SxProps = {
  display: 'flex',
  width: '662px',
  margin: '50px auto',
  flexDirection: 'column',
  gap: '16px',

  '@media screen and (max-width: 662px)': {
    width: '90%',
  },
};

export const inputsBlock: SxProps = {
  display: 'flex',
  gap: '24px',
  width: '100%',

  '@media screen and (max-width: 662px)': {
    flexDirection: 'column',
  },
};

export const inputDiv: SxProps = {
  border: '1px solid #eaeaea',
  borderRadius: '8px',
  height: '64px',
  padding: '13px 16px',
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  justifyContent: 'space-between',
};

export const inputDivDisabled: SxProps = {
  border: '1px solid #eaeaea',
  borderRadius: '8px',
  height: '64px',
  padding: '13px 16px',
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  justifyContent: 'space-between',
  background: '#f6f6f6',
};

export const input: SxProps = {
  fontSize: '17px',
  fontWeight: '500',
  paddingBlock: '0 !important',
  paddingInline: '0 !important',
  height: '38px',

  '&.MuiOutlinedInput-root fieldset': {
    border: 'none',
    width: '90%',
    padding: 0,
  },
};

export const btn: SxProps = {
  mt: '40px',
  width: '100%',
};

export const infoText: SxProps = {
  color: '#939393',
  fontSize: '16px',
  fontWeight: 400,
  mt: '60px',
};

export const infoDataText: SxProps = {
  color: '#939393',
  fontSize: '12px',
  fontWeight: 400,
};

export const userInfoText: SxProps = {
  fontSize: '12px',
  color: '#939393',
  position: 'relative',
  textAlign: 'center',
  mt: '40px',
  mb: '24px',

  '&:before': {
    content: "''",
    display: 'block',
    width: '36%',
    height: '2px',
    background: '#eaeaea',
    left: 0,
    top: '50%',
    position: 'absolute',
  },

  '&:after': {
    content: "''",
    display: 'block',
    width: '36%',
    height: '2px',
    background: '#eaeaea',
    right: 0,
    top: '50%',
    position: 'absolute',
  },
};

export const styles = {
  container: (base?: any) => ({
    ...base,
    width: '100%',
  }),
  control: (base?: any, state?: any) => ({
    ...base,
    backgroundColor: state.isDisabled ? '#f6f6f6' : '#fff',
    height: '38px',
    boxShadow: 'none',
    border: 'none',
    borderRadius: '10px',

    // ':hover': {
    //   borderColor: gray9,
    // },
  }),
  valueContainer: (provided?: any, state?: any) => ({
    ...provided,
    overflow: 'visible',
    textOverflow: 'ellipsis',
    padding: '0',
  }),
  placeholder: (provided?: any, state?: any) => ({
    ...provided,
    position: 'absolute',
    top: (state.hasValue || state.selectProps.inputValue) && -10,
    backgroundColor: 'transparent',
    width: 'fit-content',
    padding: state.hasValue || state.selectProps.inputValue ? '0 5px' : '0 0 0 2px',
    textAlign: state.hasValue || state.selectProps.inputValue ? 'center' : 'left',
    transition: 'top 0.1s, font-size 0.1s',
    fontSize: state.hasValue || state.selectProps.inputValue ? 9 : 17,
    left: '-3px',
    color: 'rgb(158 158 158)',
    fontWeight: '400',
    marginLeft: 0,
    marginRight: 0,
    lineHeight: 1,
    fontFamily: 'Yelo',
  }),
  dropdownIndicator: (base?: any, state?: any) => ({
    ...base,
    color: '#939393',
  }),
  menu: (base?: any) => ({
    ...base,
    zIndex: '9999999',
  }),
  option: (provided?: any, state?: any) => ({
    backgroundColor: '#fff',
    color: '#000',
    padding: '16px 10px',

    ':hover': {
      cursor: 'pointer',
    },
  }),
};

// .info-text{
//     color: #939393;
//     font-size: 16px;
//     font-weight: 400;
// }
//
// .user-info-text{
//     font-size: 12px;
//     color: #939393;
//     position: relative;
//     text-align: center;
// }
//
// .user-info-text:before{
//     content: "";
//     display: block;
//     width: 40%;
//     height: 2px;
//     background: #eaeaea;
//     left: 0;
//     top: 50%;
//     position: absolute;
// }
//
// .user-info-text:after{
//     content: "";
//     display: block;
//     width: 40%;
//     height: 2px;
//     background: #eaeaea;
//     right: 0;
//     top: 50%;
//     position: absolute;
// }
